
const restrictecEmails = ["belgiantrain.be","ext.belgiantrain.be","sncb.be","nmbs.be","ypto.be","belgianrail.be"];
	
const isRestrictEmail = (email) => {
		if(email) {
			let emailCondition = false;
			const splitedEmail = email.split('@');
			const splitedStringForDomain = splitedEmail[1];
		
			 
			const convertingEmailToLowerCase = splitedStringForDomain  && splitedStringForDomain.toLowerCase();
			
			 restrictecEmails.forEach((domain) => {
				if(domain.includes(convertingEmailToLowerCase)) {
					emailCondition = true;
				}
			 });

			 if(emailCondition) {
				return true;
			 } else {
				return false;
			 }
		} 
		
		
	}

	const isValidEmailInput = (email) => {
        return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
    }
export {isRestrictEmail,isValidEmailInput}
